<template>
  <div
    class="navBar"
    :style="{ backgroundColor: opacity ? 'rgba(255, 255, 255, 0)' : '#EDEDED' }"
  >
    <div class="arrowLeft" @click="handleBackClick">
      <img :src="arrowLeft" alt="" />
    </div>
    <p v-show="narBarTitle" class="title">{{ narBarTitle }}</p>
    <div v-if="okButton" class="submit" @click="onSubmit">{{ $t('完成') }}</div>
    <div v-else class="submit-none"></div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Icon } from 'vant'
import arrowLeft from '@/assets/images/arrow-left.svg'
Vue.use(Icon)
export default {
  name: 'NavBar',
  props: {
    narBarTitle: String, //navBar的title
    onSubmit: Function, //完成功能回调
    okButton: Boolean, //是否显示完成按钮
    opacity: Number,
  },
  data() {
    return {
      arrowLeft,
    }
  },
  methods: {
    handleBackClick() {
      if (this.$listeners['click-left']) {
        this.$emit('click-left')
      } else {
        this.$router.back()
      }
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .van-nav-bar .van-icon {
  color: #000000;
}
.navBar {
  height: 44px;
  width: 100%;
  display: flex;
  position: relative;
  padding: 10px 16px;
  justify-content: space-between;
  align-items: center;
  .arrowLeft {
    width: 24px;
    height: 24px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    color: #1e2329;
    line-height: 24px;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-style: normal;
    margin-left: 32px;
  }
}
.submit {
  width: 56px;
  height: 32px;
  background-color: #3972ff;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-style: normal;
  color: #ffffff;
  font-weight: 500;
  line-height: 32px;
}
.submit-none {
  width: 56px;
  height: 32px;
}
</style>
